import React from 'react';
import { Image } from 'antd';
import GenericTable from '../components/GenericTable';
import GenericForm from '../components/GenericForm';
import { services } from '../services/api';

const columns = [
  {
    title: 'Logo',
    dataIndex: 'SponsorLogoUrl',
    key: 'logo',
    width: 70,
    render: (url) => url
      ? <Image src={url} width={40} height={40} style={{ objectFit: 'contain' }} preview={{ mask: false }} />
      : <div style={{ width: 40, height: 40, background: '#f0f0f0', borderRadius: 4 }} />,
  },
  { title: 'Nombre', dataIndex: 'SponsorNombre', key: 'nombre' },
  { title: 'Logo URL', dataIndex: 'SponsorLogoUrl', key: 'url', ellipsis: true, render: (url) => url || '–' },
];

const formFields = [
  { name: 'SponsorNombre', label: 'Nombre', type: 'text', required: true },
  { name: 'SponsorLogoUrl', label: 'URL del Logo', type: 'text' },
];

const FormComponent = (props) => <GenericForm fields={formFields} {...props} />;

const Sponsors = () => (
  <GenericTable
    service={services.sponsors}
    columns={columns}
    FormComponent={FormComponent}
    title="Sponsors"
    searchFields={[{ key: 'SponsorNombre', label: 'Nombre' }]}
  />
);

export default Sponsors;
